export interface CreateAddonRequest {
  shortCode: string;
  quantity: number;
}

export interface CreateSubscriptionRequest {
  shortCode: string; // planId
  addons: CreateAddonRequest[];
}
